import { SomacylOrderENTITY } from 'sigo-entities'
import { HorizontalShowInfo } from '../../shared/Components/HorizontalShowInfo'
import { Button } from 'react-bootstrap'
import { AdapterGenerico } from '../../shared/Infraestructure/AdapterGenerico'

interface IProps {
    row: SomacylOrderENTITY
}

export function InfoOrder(props: IProps) {
    const { row } = props

    const onNavigateUbication = () => {
        try {
            const lat = row.ubicacion.direccion_polar_y;
            const lng = row.ubicacion.direccion_polar_x;

            const url = `https://www.google.com/maps?q=${lat},${lng}`;

            window.open(url, '_blank');
        } catch (error) {
            console.error(error)
            AdapterGenerico.createMessage('Alerta', (error as Error).message, 'error')
        }
    }

    return (
        <div style={{ display: 'flex', flexDirection: 'column' }}>
            {(row.ubicacion.direccion_polar_x && row.ubicacion.direccion_polar_y) && (
                <Button variant='link' style={{ alignSelf: 'end' }} onClick={onNavigateUbication}>
                    <i className='fa-solid fa-location-dot' />
                </Button>
            )}
            <HorizontalShowInfo label='Orden' value={row.numero_de_peticion} />
            <HorizontalShowInfo label='Actividad' value={row.subtipo_de_actividad} />
            <HorizontalShowInfo label='Dirección' value={row.ubicacion.direccion_completa_y_referencia} />
            <HorizontalShowInfo label='Localidad' value={row.ubicacion.localidad} />
            <HorizontalShowInfo label='Provincia' value={row.ubicacion.nombre_de_provincia} />
            <HorizontalShowInfo label='Distrito' value={row.ubicacion.nombre_distrito} />
            <HorizontalShowInfo label='Tipo vivienda' value={row.ubicacion.tipo_de_vivienda} />
            <HorizontalShowInfo label='Calibre existente' value={row.inventario_existente.calibre_contador_existente} />
            <HorizontalShowInfo label='Serie existente' value={row.inventario_existente.num_serie_contador_existente} />
            <HorizontalShowInfo label='Zona de Trabajo' value={row.ubicacion.zona_de_trabajo} />
            <HorizontalShowInfo label='Observaciones' value={row.observaciones_en_legados} />
            <HorizontalShowInfo label='Latitud' value={row.ubicacion.direccion_polar_y.toString()} />
            <HorizontalShowInfo label='Longitud' value={row.ubicacion.direccion_polar_x.toString()} />
            <HorizontalShowInfo label='Nombre cliente' value={row.nombre_cliente} />
            <HorizontalShowInfo label='Telefono cliente' value={row.numero_telefono || row.telefono_contacto_2} />
        </div>
    )
}